<template>
  <div class="btn-follow-wrapper" :class="{ unactive: !activable }">
    <div class="btn-follow">
      <svg
        class="icon-plus"
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
      >
        <path
          fill="#FFF"
          fill-rule="nonzero"
          d="M28.75 20.75h-9v9a2.25 2.25 0 0 1-4.5 0v-9h-9a2.25 2.25 0 1 1 0-4.5h9v-9a2.25 2.25 0 1 1 4.5 0v9h9a2.25 2.25 0 0 1 0 4.5z"
        />
      </svg>
      关注
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class BtnFollow extends Vue {
  @Prop({ type: Boolean, default: true }) activable!: boolean;
}
</script>

<style lang="scss" scoped>
@import '@style/helps.scss';
.btn-follow-wrapper {
  display: inline-flex;
  width: 183px;
  height: 88px;
  font-size: 40px;
  background: #fff;
  border-radius: 8px;
  &:not(.unactive):active {
    .btn-follow {
      opacity: 0.7;
    }
  }
}
.btn-follow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #ffffff;
  font-weight: 600;
  background: #fa6755;
  border-radius: 8px;
  user-select: none;
  @include forbid-select;
  .icon-plus {
    width: 36px;
    height: 36px;
    margin-right: 10px;
  }
}
.small {
  width: 140px;
  height: 60px;
  font-size: 34px;
}
</style>
